import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Typography, Box, ThemeProvider, Grid } from "@mui/material";
import Footer from "src/components/footer/footer";
import theme from "src/styles/mainstyle";
import Header from "src/components/header/header";
import ContentBox from "src/components/ContentBox/ContentBox";
import { textStyle } from "src/styles/textstyle";
import ReactMarkdown from "react-markdown";
import invite_friends from "src/media/invite_friends.jpg";

// Webpack: require all .md files in ../media/articles
const req = require.context("../media/articles", true, /eng\.md$/);
const imgReq = require.context(
  "../media/articles",
  true,
  /\.(jpe?g|png|gif|webp)$/,
);

export default function Articles() {
  const [articles, setArticles] = useState<
    { slug: string; title: string; preview: string; image: string }[]
  >([]);

  useEffect(() => {
    async function loadArticles() {
      const loaded = await Promise.all(
        req.keys().map(async (key) => {
          const parts = key.split("/");
          const slug = parts[1]; // {title}
          const file = req(key);
          const response = await fetch(
            (file as { default: string }).default || (file as string),
          );

          const imagesInFolder = imgReq.keys().filter((imgPath) => {
            console.log(imgPath);
            return imgPath.startsWith(`./${slug}/`);
          });
          const firstImage =
            imagesInFolder.length > 0
              ? imgReq(imagesInFolder[0])
              : invite_friends;
          const content = await response.text();
          const contentLines = content
            .split("\n")
            .filter((line) => line.trim() !== "");
          const title = contentLines[0].replace(/^# /, "") || slug;
          const preview = contentLines.slice(1, 6).join(" ");
          return { slug, title, preview, image: firstImage };
        }),
      );
      setArticles(loaded);
    }
    loadArticles();
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Header />
        <Box sx={{ p: 3 }}>
          <Typography variant="h3" gutterBottom>
            Articles
          </Typography>
          {articles.map((article, index) => (
            <ContentBox title=" " key={article.slug} sx={{ mb: 2 }}>
              <Grid container spacing={5}>
                <Grid item xs={12} md={6}>
                  <Link
                    to={`/articles/${article.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        ...textStyle,
                        fontWeight: "bold",
                        fontSize: { xs: "2.2rem", md: "2.8rem" }, // Larger title, responsive
                        marginBottom: "20px",
                        textDecoration: "none",
                        transition: "text-decoration 0.2s",
                        "&:hover": {
                          textDecoration: "underline",
                          cursor: "pointer",
                        },
                      }}
                    >
                      {article.title}
                    </Typography>
                  </Link>
                  <ReactMarkdown>
                    {article.preview.length > 120
                      ? article.preview.slice(0, 120) + "..."
                      : article.preview}
                  </ReactMarkdown>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div
                    style={{
                      position: "relative",
                      paddingBottom: "36.25%",
                      height: 0,
                      overflow: "hidden",
                      maxWidth: "100%",
                      borderRadius: "12px",
                    }}
                  >
                    <img
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // Ensure the image covers the container while maintaining aspect ratio
                      }}
                      src={article.image} // Replace with the URL of your image
                      alt={article.title}
                    />
                  </div>
                </Grid>
              </Grid>
            </ContentBox>
          ))}
        </Box>
      </ThemeProvider>
      <Footer />
    </>
  );
}
